var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 6.07728C18.67 2.60599 15.64 0 12 0C9.11 0 6.6 1.65012 5.35 4.06494C2.34 4.38691 0 6.95266 0 10.0617C0 11.6629 0.632141 13.1984 1.75736 14.3306C2.88258 15.4627 4.4087 16.0988 6 16.0988H19C19.6566 16.0988 20.3068 15.9686 20.9134 15.7158C21.52 15.463 22.0712 15.0924 22.5355 14.6253C22.9998 14.1581 23.3681 13.6035 23.6194 12.9931C23.8707 12.3828 24 11.7286 24 11.0679C24 8.41161 21.95 6.2584 19.35 6.07728ZM19 14.0864H6C4.93913 14.0864 3.92172 13.6624 3.17157 12.9076C2.42143 12.1528 2 11.1291 2 10.0617C2 7.99907 3.53 6.27852 5.56 6.06722L6.63 5.95654L7.13 5.00068C8.08 3.15938 9.94 2.01235 12 2.01235C14.62 2.01235 16.88 3.88383 17.39 6.46969L17.69 7.97895L19.22 8.08963C20.78 8.19025 22 9.50833 22 11.0679C22 11.8685 21.6839 12.6362 21.1213 13.2023C20.5587 13.7684 19.7956 14.0864 19 14.0864ZM8 9.05556H10.55V12.0741H13.45V9.05556H16L12 5.03086L8 9.05556Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7a3f30c8e890a6e89c331a2e283941a4.svg";
export { ForwardRef as ReactComponent };